import {
    createFeatureSelector,
    createReducer,
    createSelector,
    on,
    StoreModule,
} from '@ngrx/store';
import { Parcel } from 'src/app/models/parcel';
import { SetActiveParcel } from './parcels.action';

const featureName = 'parcel';

export interface ParcelState {
    activeParcel: Parcel;
}

export const initialState: ParcelState = {
    activeParcel: {
        address: '',
        agency: '',
        description: '',
        id: '',
        negdistance: 0,
        owner: '',
        size: 0,
        type: '',
    },
};

export const getParcelFeatureState =
    createFeatureSelector<ParcelState>(featureName);

export const selectActiveParcel = createSelector(
    getParcelFeatureState,
    (state) => state.activeParcel
);
export const activeParcelReducer = createReducer(
    initialState,
    on(SetActiveParcel, (state, { parcel }) => {
        return {
            ...state,
            activeParcel: parcel ? parcel : initialState.activeParcel,
        };
    })
);

export const parcelStoreModule = StoreModule.forFeature(
    featureName,
    activeParcelReducer
);
